import React, { Fragment, useRef, useState } from 'react'
import Footer from '../../component/Other/Footer'
import Navbar from '../../component/Other/Navbar'
import Head from '../../component/Page/Head'
import SecContact from '../../component/Page/SecContact'
import { NavLink } from 'react-router-dom'

const Service = () => {
    const serviceList = [
        {
            title: "Plant Rentals",
            desc: "If you're looking to add some greenery to your office or event space, our plant rental service is the perfect solution. ",
            link: "/service/detail"
        },
        {
            title: "Custom Plant Design",
            desc: "We believe that plants should be an integral part of any space, and our custom plant design service allows us to create unique.",
            link: "/service/detail"
        },
        {
            title: "Plant Maintenance",
            desc: "Plants require regular care and maintenance to stay healthy and thrive, and our plant maintenance service ensures that your plants...",
            link: "/service/detail"
        },
        {
            title: "Green Wall Installation",
            desc: "Green walls are a stunning and innovative way to add greenery to any indoor or outdoor space. Our green wall installation service allows us to ....",
            link: "/service/detail"
        },
        {
            title: "Plant Delivery",
            desc: "We offer plant delivery services to make it easy for you to enjoy the benefits of plants without the hassle of transportation. Our team will.. ",
            link: "/service/detail"
        },
        {
            title: "Plant Consultation",
            desc: " If you're not sure where to start with your plant journey, our plant consultation service is the perfect solution. Our team of experts will...",
            link: "/service/detail"
        },
    ]
    return (
        <Fragment>
            <div className="overflow-hidden">
                <div className="position-relative">
                    <Navbar />
                    <Head title={"Our Service"} to={"Our Service"} />
                </div>

                <section className='mb-5'>
                    <div className="container">
                        <div className="text-center mb-5">
                            <h3 className='normal font__size--50 text__50-1024 text__50-sm text__50-xs quest'>Our Services</h3>
                            <p className="normal font__size--14 text__14-1024 color__gray-1">At Bloom & Grow, we offer a wide range of plant-related services to cater to your needs. From plant rentals to custom plant designs, we have <br className='d-none d-lg-block' /> everything you need to create a green and inviting space. Our team of experts has years of experience in the industry and is dedicated to <br className='d-none d-lg-block' /> providing high-quality services that meet your specific requirements.</p>
                        </div>

                        <div className="row">
                            {
                                serviceList.map((obj) => {
                                    return <div className="col-md-6 col-lg-4 mb-4">
                                        <div className="wrapper__grid-servie">
                                            <svg className='mb-4 icon' width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <g clip-path="url(#clip0_229_3197)">
                                                    <path d="M37.6554 0C29.6583 0 20 5.74219 20 12.8729C20 12.9147 20.0115 13.0336 20.0169 13.0753C20.0302 13.4802 20.309 13.8281 20.7014 13.9276C21.0911 14.0279 21.5058 13.8566 21.7099 13.5067C24.1007 9.42827 27.6074 6.29174 32.4326 3.91688C32.8792 3.69316 33.4314 3.89199 33.6479 4.33057C33.7553 4.54901 33.7713 4.79574 33.6932 5.02569C33.615 5.25563 33.4526 5.44117 33.2351 5.5477C27.8126 8.21796 24.1694 11.8931 22.0919 16.775C22.0581 16.8247 22.0154 16.8661 21.9913 16.9238C20.688 20.0665 20.0178 23.7961 20 28.0095C19.6792 27.1646 19.3005 26.3609 18.893 25.5772C19.6156 24.4687 20 23.2625 20 21.9638C20 14.8331 10.3417 9.09086 2.3446 9.09086C1.05205 9.09094 0 10.1429 0 11.4355C0 19.4327 5.74219 29.0909 12.8738 29.0909C14.6282 29.0909 16.2181 28.4044 17.615 27.0898C19.2082 30.4489 20 34.3936 20 39.091C20 39.5935 20.4066 40.0001 20.9091 40.0001C21.4116 40.0001 21.8182 39.5935 21.8182 39.091V28.1819C21.8182 24.624 22.3289 21.4735 23.2819 18.7426C24.4545 19.5725 25.7415 20 27.1271 20C34.2578 20 40 10.3418 40 2.34469C40 1.05205 38.948 0 37.6554 0Z" fill="#809D79" />
                                                </g>
                                                <defs>
                                                    <clipPath id="clip0_229_3197">
                                                        <rect width="40" height="40" fill="white" />
                                                    </clipPath>
                                                </defs>
                                            </svg>
                                            <h5 className='semi-bold font__size--24 text__24-1024'>{obj.title}</h5>
                                            <p className='normal font__size--14 text__14-1024 color__gray-1 mb-3'>{obj.desc}</p>

                                            <NavLink to={obj.link} className="d-inline-block color__orange">
                                                <div className="d-flex align-items-center">
                                                    <span className="medium font__size--16 text__16-1024 mr-2">Read More</span>
                                                    <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <g clip-path="url(#clip0_217_4732)">
                                                            <path d="M1.20211 9.00198C1.28395 8.9887 1.36676 8.98257 1.44963 8.98365H15.5592L15.2516 8.84055C14.9508 8.69821 14.6772 8.50449 14.4431 8.26815L10.4864 4.31147C9.96527 3.81402 9.87771 3.01378 10.2789 2.41541C10.7458 1.77777 11.6412 1.63932 12.2789 2.10622C12.3304 2.14397 12.3793 2.18511 12.4254 2.22938L19.5803 9.38433C20.1395 9.94286 20.14 10.8489 19.5814 11.4081C19.5811 11.4084 19.5807 11.4088 19.5803 11.4092L12.4254 18.5641C11.8658 19.1222 10.9597 19.1209 10.4016 18.5613C10.3577 18.5173 10.3167 18.4704 10.2789 18.421C9.87771 17.8226 9.96527 17.0224 10.4864 16.525L14.4359 12.5611C14.6459 12.3509 14.8872 12.1747 15.1514 12.0388L15.5807 11.8456H1.52838C0.797363 11.8728 0.156012 11.3621 0.0186806 10.6436C-0.107826 9.86348 0.421997 9.12854 1.20211 9.00198Z" fill="#F48148" />
                                                        </g>
                                                        <defs>
                                                            <clipPath id="clip0_217_4732">
                                                                <rect width="20" height="20" fill="white" transform="matrix(-1 0 0 1 20 0.405762)" />
                                                            </clipPath>
                                                        </defs>
                                                    </svg>
                                                </div>
                                            </NavLink>
                                        </div>
                                    </div>
                                })
                            }

                        </div>
                    </div>
                </section>

                <SecContact />

                <Footer />
            </div >
        </Fragment >
    )
}

export default Service